import type { ICellRendererParams } from 'ag-grid-community';

import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { PulledSemenType } from '@/types.gql';
import { useCrmUrl } from '@/utils/crm-url';

export const PulledSemenName = ({
  value,
  data,
}: ICellRendererParams<PulledSemenType>) => {
  const isNucleusLinkEnabled = useFeatureFlag('Fert_Nucleus_Hyperlinks');
  const baseUrl = useCrmUrl();
  if (isNucleusLinkEnabled) {
    if (!data?.semenID) {
      return value;
    }

    return (
      <a
        href={`/semen/detail?semenId=${data.semenID}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {value}
      </a>
    );
  }

  if (!baseUrl) {
    return value;
  }

  const url = new URL('main.aspx', baseUrl);
  url.searchParams.set('etc', '10029');
  url.searchParams.set(
    'extraqs',
    'formid=2d624d97-c1df-4829-be50-f32cd3e5f3bc',
  );
  url.searchParams.set('id', `{${data?.semenID}}`);
  url.searchParams.set('pagetype', 'entityrecord');

  return (
    <a href={url.toString()} target="_blank" rel="noopener noreferrer">
      {value}
    </a>
  );
};
